import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { getInformationFromValues, getProductPricing, formatCents } from './pricingUtils';

const useStyles = makeStyles(() => ({
  rowContainer: {
    maxWidth: '70%',
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  productNumber: {
    width: '6rem',
  },
  description: {
    flexBasis: 0,
    flexGrow: 1,
  },
  totalPriceRow: {
    justifyContent: 'spaceBetween',
  },
  totalPrice: {
    fontWeight: 600,
  },
}));

export const ProductPricing = observer(({ productName, subformValues, facilities }) => {
  const classes = useStyles();
  if (!subformValues) {
    return;
  }

  const facilityCount = facilities.length;
  const { product, years } = getInformationFromValues(productName, subformValues);
  const pricing = getProductPricing({
    productName,
    product,
    years,
    facilityCount,
    details: subformValues,
  });

  return (
    <div className={classes.rowContainer}>
      {pricing.map((price, i) => (
        <div className={classes.row} key={i}>
          <Typography
            variant="caption"
            className={classes.productNumber}
          >{`${price.productNumber}`}</Typography>
          <Typography
            variant="caption"
            className={classes.description}
          >{`${price.description}`}</Typography>
          <Typography variant="caption">
            {price.promoLabel ? (
              <>
                <s>{formatCents(price.listPrice)}</s> ({price.promoLabel})
              </>
            ) : (
              formatCents(price.price)
            )}
          </Typography>
        </div>
      ))}
      {(productName === 'FACILITY360' || productName === 'AM_VISION') && (
        <div className={classes.row}>
          <Typography variant="body2" className={classes.totalPrice}>
            Total
          </Typography>
          <Typography variant="body2" className={classes.totalPrice}>
            {formatCents(
              pricing.reduce((overallPrice, currPrice) => overallPrice + currPrice.price, 0),
            )}
          </Typography>
        </div>
      )}
    </div>
  );
});
